import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Tabs, Tab, Grid, Row, Col} from 'react-bootstrap'
import PageTitle from '../common/page-title'
import InlineCKEditor from '../common/editor/inline-editor'
import CompleteOrders from './complete-orders'
import SavedOrders from './saved-orders'
import {history} from '../../store';
import {loadPageContent} from '../../actions/content';

class MyOrders extends Component {
  constructor(props) {
    super(props);

    let tab = this.props.location.hash;
    if (!tab) {
      tab = 'complete';
      history.replace(`/my-orders#${tab}`);
    } else {
      tab = tab.substr(1);
    }

    this.pageSlug = 'my-orders';
    this.state = {tab};
  }

  componentWillMount() {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleTabSelect = (tab) => {
    history.replace(`/my-orders#${tab}`);
    this.setState({tab});
  };

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <Grid bsClass="container" className="orders">
        <Row>
          <Col lg={12}>
            <PageTitle>Orders</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Tabs activeKey={this.state.tab} onSelect={this.handleTabSelect} id="myOrdersTab">
              <Tab eventKey="complete" title="COMPLETE ORDERS">
                <CompleteOrders/>
              </Tab>
              <Tab eventKey="saved" title="SAVED ORDERS">
                <SavedOrders/>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(MyOrders)


// WEBPACK FOOTER //
// ./src/components/my-orders/index.jsx